import React, { Component } from 'react';
import { connect} from "remx";
import { Link } from "react-router-dom";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";

class SidebarDataMaster extends Component {
    constructor(props) {
        super(props);
    
        this.state = {

        }

    }

    componentDidMount(){
        dataStore.setters.setDataPer({})
    }

    render(){
        return(
            <div id="sidebarMenu" className="sidebar sidebar-fixed sidebar-components">
                <div className="filemgr-sidebar-body" style={{padding: '25px', top: '1px'}}>
                    <div className="pd-b-10 pd-x-10">
                        <label className="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Master Data</label>
                        <nav className="nav nav-sidebar tx-13">
                        <Link to='/master/user' className={(this.props.location === '/master/user') ? 'nav-link active' : 'nav-link'}><i className="far fa-folder mg-r-10"></i>Data User</Link>
                        <Link to='/master/kategori' className={(this.props.location.substring(0, 16) === '/master/kategori') ? 'nav-link active' : 'nav-link'}><i className="far fa-folder mg-r-10"></i>Data Kategori</Link>
                        {/* <Link to='/master/klasifikasi' className={(this.props.location === '/master/klasifikasi') ? 'nav-link active' : 'nav-link'}><i className="far fa-folder mg-r-10"></i>Data Klasifikasi</Link> */}
                        <Link to='/master/pelanggan' className={(this.props.location === '/master/pelanggan') ? 'nav-link active' : 'nav-link'}><i className="far fa-folder mg-r-10"></i>Data Pelanggan</Link>
                        <Link to='/master/telegram' className={(this.props.location === '/master/telegram') ? 'nav-link active' : 'nav-link'}><i className="far fa-folder mg-r-10"></i>Data Telegram</Link>
                        {/* <a href="#" className="nav-link"><i data-feather="trash"></i> <span>Deleted Files</span></a> */}
                        </nav>
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
    }
}

export default connect(mapStateToProps)(SidebarDataMaster);